import { Filter } from "../filter";

export class UserDataFilter extends Filter {

    constructor(
        public resource: boolean = true,
        public notResource : boolean = true,
        public dataTypes: string[] = [],
        public departments:    string[] = [],
        public orgUnits:       string[] = [],
        public financialUnits: string[] = [],
        value : string = "") {
        super(value);
    }


    protected override onReset() : void {
        this.resource = true;
        this.notResource = true;
        this.dataTypes      = [];
        this.departments    = [];
        this.orgUnits       = [];
        this.financialUnits = [];
    }
}